import React from "react";
import { MessageCircle, Instagram, Star } from "lucide-react";

const Contact: React.FC = () => {
  const phoneNumber = "4917663182248"; 
  const instagramUsername = "17842955601344722/";

  const testimonials = [
    {
      name: "Dilara",
      text: "Ich bin absolut begeistert! Heute hatte ich meine erste Laserbehandlung und habe mich bei Mariam sofort rundum wohl gefühlt. Sie ist nicht nur äußerst freundlich und herzlich, sondern auch sehr kompetent. Vor der Behandlung wurde ich hervorragend beraten, was mir ein sicheres Gefühl gegeben hat. Ich kann sie zu 100 % weiterempfehlen und freue mich schon auf meinen nächsten Termin!",
      rating: 5
    },
    {
      name: "Nida",
      text: "Ich war bei Beautique Mariam und bin total begeistert! Mariam ist nicht nur unglaublich professionell, sondern auch super herzlich – man fühlt sich sofort wohl. Die Behandlung war perfekt auf meine Bedürfnisse abgestimmt, und das Ergebnis hat meine Erwartungen übertroffen. Man merkt, dass hier mit viel Liebe zum Detail gearbeitet wird. Das Studio ist modern und gemütlich eingerichtet, sodass man direkt entspannen kann. Ich komme auf jeden Fall wieder und kann es jedem nur wärmstens empfehlen!",
      rating: 5
    },
    {
      name: "Baraa",
      text: "Ich war heute im Salon und bin absolut begeistert von den Ergebnissen! Meine Haut sieht strahlend aus und meine Augenbrauen waren noch nie so schön! (Sehr freundlich) Ich kann den Salon nur empfehlen, ich werde auf jeden Fall wiederkommen :))",
      rating: 5
    },
  ];

  return (
    <div className="bg-[#FAF7F2] min-h-screen px-6 py-24 flex flex-col items-center text-center">
      {/* Titel */}
      <h1 className="text-4xl md:text-5xl font-light text-[#7A6E62] mb-12">Kontakt</h1>
      <p className="text-[#8C8378] text-lg md:text-xl max-w-3xl mb-16">
        Treten Sie direkt mit uns in Kontakt – über WhatsApp oder Instagram. Wir antworten so schnell wie möglich!
      </p>

      {/* Zweispaltiges Layout: Buttons links, Map rechts */}
      <div className="w-full max-w-6xl grid md:grid-cols-2 gap-12 items-center mb-20">
        {/* Links: Buttons */}
        <div className="flex flex-col gap-6 items-center md:items-start">
          <a
            href={`https://wa.me/${phoneNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-[#25D366] hover:bg-[#1DA851] text-white px-8 py-4 rounded-2xl shadow-lg transition transform hover:-translate-y-1 hover:shadow-2xl"
          >
            <MessageCircle size={28} />
            <span className="text-lg md:text-xl font-medium">WhatsApp Nachricht</span>
          </a>

          <a
            href={`https://www.instagram.com/direct/t/${instagramUsername}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-gradient-to-r from-[#f09433] via-[#bc1888] to-[#e6683c] hover:opacity-90 text-white px-8 py-4 rounded-2xl shadow-lg transition transform hover:-translate-y-1 hover:shadow-2xl"
          >
            <Instagram size={28} />
            <span className="text-lg md:text-xl font-medium">Instagram Nachricht</span>
          </a>
        </div>

        {/* Rechts: Google Maps */}
        <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl border border-[#E5E5E5]">
          <iframe
            title="Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2660.56641271365!2d11.5732103!3d48.176437299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x27ccb0d86bce44af%3A0xb87de625d12718d1!2sBeautique%20Mariam!5e0!3m2!1sde!2sde!4v1764060828046!5m2!1sde!2sde" 
            width="100%"
            height="100%"
            className="border-0"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Kundenbewertungen */}
      <section className="w-full max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-light text-[#7A6E62] mb-10 text-center">Kundenbewertungen</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-8 shadow-xl flex flex-col items-start gap-4 transform hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} size={20} className="text-yellow-400" />
                ))}
              </div>
              <p className="text-[#8C8378] text-base md:text-lg">{t.text}</p>
              <span className="text-[#7A6E62] font-medium mt-2">- {t.name}</span>
            </div>
          ))}
        </div>
      </section>
      {/* Sticky Pfeil unten */}
      <div className="sticky bottom-4 flex justify-center">
        <a href="#next-section" className="animate-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-gray-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default Contact;
